<template>
  <Header></Header>
  <div class="main-height d-flex justify-content-center align-items-center">
    <section class="activated w-100">
      <div class="container text-center">
        <div class="inner-container">

          <h2 class="fw-bold mb-4">
            Payment in Process
          </h2>

          <!-- Processing -->
          <div v-if="paymentStatus === 'processing'">
            <div class="button-loading">
              <div class="spinner-border dates text-primary" role="status">
                <span class="sr-only"></span>
              </div>
            </div>
          </div>

          <!-- Warning -->
          <div v-else-if="paymentStatus === 'warning'">
            <div class="text-3 mt-2" v-html="errorMessage"></div>
          </div>

          <!-- Error -->
          <div v-else-if="paymentStatus === 'error'">
            <div class="text-3 mt-2 text-danger">
              {{ errorMessage }}
            </div>
            <p class="mt-2">
              Please try again later, or
              <a href="https://procricket.help/contact/" target="_blank">contact support</a>.
            </p>
          </div>

        </div>
      </div>
    </section>
  </div>
  <Footer></Footer>
</template>

<script>
import { defineComponent } from 'vue'
import Header from "@/components/Header.vue"
import Footer from "@/components/Footer.vue"
import UsersService from "@/services/users-service"
import AuthService from "@/services/auth-service"
import PaypalService from "@/services/paypal-service"

export default defineComponent({
  name: "PaymentProcess",
  components: { Header, Footer },
  data() {
    return {
      paymentStatus: 'processing',
      errorMessage: '',
      token: null
    }
  },
  methods: {
    async captureOrder(orderId) {
      try {
        const result = await PaypalService.captureOrder(orderId)
        if (result) {
          this.$router.push('/payment-success')
        } else {
          this.paymentStatus = 'warning'
          this.errorMessage = `We’re verifying your PayPal payment. This may take a few minutes.
          Once confirmed, your subscription will be processed automatically.<br> <br>
          <span class="payment-hint">
            You can check the updated expiry date and payment status in
            <a class="payment-hint" href="/account"><b>My Account</b></a> →
            <a class="payment-hint" href="/payment-history"><b>Payment History</b></a>.
          </span>`;
        }
      } catch (error) {
        this.paymentStatus = 'error'
        this.errorMessage = 'An unexpected error occurred.'
      }
    }
  },
  mounted() {
    const urlParams = new URLSearchParams(window.location.search)
    this.token = urlParams.get('token')

    if (this.token) {
      this.captureOrder(this.token)
    } else {
      this.paymentStatus = 'error'
      this.errorMessage = 'Missing payment token.'
    }
  },
  beforeMount() {
    UsersService.getUserProfile()
    if (localStorage.getItem('userProfile') == null) {
      AuthService.signOut().then(() => {
        this.$router.push('/signin')
      })
    }
  }
})
</script>

<style>
@import '../assets/style.css';
</style>